module.exports = __webpack_public_path__ + "static/cow-1351e94e02e0b24de6ce9f5ffad26e2c.gif";